import { useState } from "react";
import { Button, Icon } from "semantic-ui-react";

import { TagModal } from "modules/TagsDashboard/components";
import "modules/TagsDashboard/components/TagsToolbar/TagsToolbar.scss";

export const TagsToolbar = () => {
  const [isTagsModalOpen, setisTagsModalOpen] = useState(false);

  return (
    <>
      <div className="TagsToolbar">
        <Button basic icon className="add-btn" onClick={() => setisTagsModalOpen(true)}>
          <Icon className="plus" />
        </Button>
      </div>
      <TagModal isOpen={isTagsModalOpen} tag={null} onClose={() => setisTagsModalOpen(false)} />
    </>
  );
};
